module.exports = __webpack_public_path__ + "img/empty-state-dashboard.5f33d236.png";